import PrintIcon from '@mui/icons-material/Print';
import { Box, Typography } from '@mui/material';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import ResponsiveButton from '../../../FeedbackCenter/ResponsiveButton';

const classes = {
	flex: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginLeft: 1,
		paddingLeft: 1.5,
	},
};
const FeedbackHeader = ({ title, feedbackState, handlePrint }) => {
	const { t } = useTranslation(['candidate-feedback', 'common']);
	const showIcon = feedbackState === 'SUBMITTED';

	return (
		<Box sx={{ ...classes.flex, marginLeft: 1, paddingLeft: 1.5 }}>
			<Typography variant="h2" marginY={1}>
				{title}
			</Typography>
			{showIcon && (
				<Box sx={classes.flex}>
					<ResponsiveButton
						startIcon={<PrintIcon />}
						dataTestId="print-button"
						onClick={handlePrint}
						styleDesktop={classes.button}
						styleMobile={classes.buttonMobile}
						ariaLabel={t('print_or_download')}
						buttonTitle={t('print_or_download')}
					/>
				</Box>
			)}
		</Box>
	);
};

export default memo(FeedbackHeader);
